<div style="max-height: 300px; overflow-y: auto; overflow-x: hidden;">
  @for (p of list; track p.key)
  {
    <div class="form-check">
      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" [checked]="IsSelected(p)" (change)="select(p)">
      <label class="form-check-label" for="flexCheckDefault">
        {{p.name}}
      </label>
    </div>
  }
</div>
